import mergeObj from '../extraUtil/mergeTwoObj';

let chart = {
    "palettecolors":"#4F6DF0",
    "radarFillColor":"#1B2026",
    "plotFillAlpha":"80",
    "anchorBgColor":"#595A4A",
    "zeroplanethickness":"3",
    "zeroplanecolor":"#717170",
    "updateAnimDuration":"0",
    "plotfillalpha":"10",
    "numberSuffix":" Hrs"
}

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
    chart = mergeObj(chart, theme);
    let dataSource = {},
        customers = [],
        dataset = [],
        data = [],
        category = [],
        customerDataObj = {},
        customerCountObj = {};
    for (let i = 0; i < rawData.length; i++) {
        let customer = rawData[i]['customer'];
        if (!customers.includes(customer)) {
            customers.push(customer);
            category.push({
                label: customer
            });
        }
    }
    for (let i = 0; i < customers.length; i++) {
        customerDataObj[customers[i]] = 0;
        customerCountObj[customers[i]] = 0;
    }
    for (let i = 0; i < rawData.length; i++) {
        let customer = rawData[i]['customer'];
        rawData[i]['shipmentDelay'] && (customerDataObj[customer] += parseFloat(rawData[i]['shipmentDelay']));
        customerCountObj[customer] ++;
    }
    for (let index = 0; index < customers.length; index++) {
        let dataObj = {
            "value": customerDataObj[customers[index]]/customerCountObj[customers[index]]
        }
        data.push(dataObj);
    }
    dataset.push({"alpha":"40", "data": data});
    dataSource = {
        chart: chart,
        categories: [{category: category}],
        dataset: dataset
    }
    return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/avgDelayForCustomers.js